import { PRESET_LABELS, PRESET_ORDER, type PresetId } from '../_config/columns';

export const CLUSTER_VIEW_TABS = PRESET_ORDER.map((value) => ({
  value,
  label: PRESET_LABELS[value],
}));

export type ClusterViewPreset = PresetId;
